import type { ReactElement, ReactNode } from 'react';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';

export interface SplitViewProps {
  left: ReactNode;
  right: ReactNode;
}

/** Resizable side-by-side panes (editor | rendered). */
export function SplitView({ left, right }: SplitViewProps): ReactElement {
  return (
    <PanelGroup direction="horizontal" autoSaveId="slate-split" style={{ height: '100%' }}>
      <Panel defaultSize={50} minSize={20}>
        <div className="mp-pane">{left}</div>
      </Panel>
      <PanelResizeHandle className="mp-resize-handle" aria-label="Resize panes" />
      <Panel defaultSize={50} minSize={20}>
        <div className="mp-pane">{right}</div>
      </Panel>
    </PanelGroup>
  );
}
